import { forwardRef } from 'react';
import { Page } from 'react-pdf';
import './index.scss';

const prefixCls = 'PDFPage';

const PDFPage = forwardRef(
  (
    props: {
      visible: boolean;
      scale: number;
      pageIndex: number;
      width?: number;
    },
    ref: any
  ) => {
    const { visible, scale, pageIndex, width } = props;

    const ppp = {
      className: prefixCls,
      ref: ref,
      'data-page-index': pageIndex,
    };

    if (visible) {
      // @ts-ignore
      ppp['data-loaded'] = true;
    }

    return (
      <div {...ppp}>
        {visible ? (
          <Page
            pageNumber={pageIndex + 1}
            scale={scale}
            renderAnnotationLayer={false}
            renderTextLayer={false}
            onRenderTextLayerError={() => {
              /* suppress warning */
            }}
            className={`${prefixCls}-page`}
            loading={<div className={`${prefixCls}-loading`} />}
            width={width}
          />
        ) : (
          <div className={`${prefixCls}-loading`} />
        )}
      </div>
    );
  }
);

export default PDFPage;
